import React from 'react';
import { motion } from 'framer-motion';
import SafeIcon from '../common/SafeIcon';

const Hero = () => {
  return (
    <section className="relative min-h-screen flex items-center pt-20 overflow-hidden bg-brand-white">
      {/* Background Image & Overlay */}
      <div className="absolute inset-0 z-0">
        <img 
          src="https://images.unsplash.com/photo-1486406146926-c627a92ad1ab?q=80&w=2070&auto=format&fit=crop" 
          alt="Modern Architecture" 
          className="w-full h-full object-cover opacity-15 grayscale" 
        />
        <div className="absolute inset-0 bg-gradient-to-r from-white via-white/95 to-transparent"></div>
      </div>

      <div className="relative z-10 max-w-7xl mx-auto px-6 md:px-12 w-full">
        <div className="max-w-4xl">
          <motion.div 
            initial={{ opacity: 0, x: -30 }} 
            animate={{ opacity: 1, x: 0 }} 
            transition={{ duration: 0.8, delay: 0.2 }}
          >
            <h1 className="text-5xl md:text-7xl lg:text-8xl font-bold tracking-tighter leading-[1.05] mb-6 text-brand-black">
              Strategic M&A Advisory. <br />
              <span className="text-brand-gold italic">When the Stakes Are High.</span>
            </h1>
          </motion.div>

          <motion.div 
            initial={{ opacity: 0, y: 20 }} 
            animate={{ opacity: 1, y: 0 }} 
            transition={{ duration: 0.8, delay: 0.4 }}
          >
            <p className="text-xl md:text-2xl text-brand-muted font-light max-w-2xl mb-12 leading-relaxed">
              Independent, elite guidance for mergers, acquisitions, and high-impact business decisions.
            </p>
          </motion.div>

          <motion.div 
            initial={{ opacity: 0, y: 20 }} 
            animate={{ opacity: 1, y: 0 }} 
            transition={{ duration: 0.8, delay: 0.6 }}
            className="flex flex-col sm:flex-row gap-6"
          >
            <a 
              href="https://wa.me/65988702334" 
              target="_blank"
              rel="noopener noreferrer"
              className="group flex items-center justify-center gap-3 bg-brand-black text-brand-white px-8 py-5 font-bold tracking-wide hover:bg-brand-gold transition-all duration-300 shadow-xl shadow-brand-black/10"
            >
              <SafeIcon name="MessageCircle" className="text-xl" /> WhatsApp Us Now
            </a>
            <a 
              href="#cases" 
              className="group flex items-center justify-center gap-3 border-2 border-brand-black px-8 py-5 font-bold tracking-wide text-brand-black hover:bg-brand-black hover:text-brand-white transition-all duration-300"
            >
              View Case Highlights <SafeIcon name="ArrowRight" className="group-hover:translate-x-1 transition-transform" />
            </a>
          </motion.div>
        </div>
      </div>
    </section>
  );
};

export default Hero;